import pino from 'pino'

export const logger = pino({
  redact: ['ip', 'purchase.email', 'purchase.customerIP', 'message.notification.notification'],
})
